import React from "react";
import { useSavings } from "../../context/SavingsContext";
import { calculateOneTimeSavings } from "../../utils/calculations";

const OneTimeSavings: React.FC = () => {
  const { data } = useSavings();
  const oneTimeSavings = calculateOneTimeSavings(data.entries);

  const formatCurrency = (amount: number): string => {
    return amount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
    });
  };

  return (
    <div className="bg-gray-900 p-6 rounded-lg">
      <h2 className="text-xl mb-4">One-Time Savings</h2>
      <div className="text-4xl font-bold text-blue-400 mb-2">
        {formatCurrency(oneTimeSavings)}
      </div>
      <div className="text-gray-400">
        Total cost savings from one-time initiatives
      </div>
    </div>
  );
};

export default OneTimeSavings;
